export default __webpack_public_path__ + "static/media/brad sherman.8fcf2b59.jpg";